// Legacy category URL `/@lang/categories/@slug` — kept only to 301-redirect to
// the canonical `/@lang/c/@slug` (T2.3), preserving crawled links + SEO equity.
export default '/@lang/categories/@slug'
